import { z } from "zod/v4"
import { validateUserFreeInputText } from "./user-free-input-text-constraint"
import { UpdatedAt } from "./firestore/system"

export const Tag = validateUserFreeInputText({minLength: 1, maxLength: 20}).describe("タグ文字列。表示の際は # を先頭につける要件が多いので注意すること。データには # は入っていない。")
export const TagsOptional = z.array(Tag).min(0).max(10).describe("タグ一覧を示すプロパティ。0個でもOK。")
export const TagsRequired = z.array(Tag).min(1).max(10).describe("タグ一覧を示すプロパティ。1個以上の指定が必須。")
export const TagsOptionalForm = z.array(z.object({value: Tag})).min(0).max(10).describe("タグ一覧を示すプロパティ。0個でもOK。")
export const TagsRequiredForm = z.array(z.object({value: Tag})).min(1).max(10).describe("タグ一覧を示すプロパティ。1個以上の指定が必須。")

export const MediaImage = z.object({
  kind: z.literal("image").describe("画像。"),
  value: z.string().describe("画像のpublic URL。HTTP でアクセスできる。updated_at のタイムスタンプがクエリパラメータとして付与される。"),
  location: z.string().describe("画像のURL。`gs://` から始まる Firebase Storage の URL です。"),
  updated_at: UpdatedAt.describe("メディアの更新日時。value の URL にクエリパラメータとして付与され、キャッシュ無効化に使用される。"),
  variants: z.record(z.string(), z.string()).optional().describe("CDN 変換済みバリアント URL のマップ。キー名は変換パラメータを示す（例: w-512h-512q-80f-webp）。値は変換済みの public URL。"),
})

export const MediaVideo = z.object({
  kind: z.literal("video").describe("動画。"),
  value: z.string().describe("動画のpublic URL。HTTP でアクセスできる。updated_at のタイムスタンプがクエリパラメータとして付与される。"),
  location: z.string().describe("動画のURL。`gs://` から始まる Firebase Storage の URL です。"),
  updated_at: UpdatedAt.describe("メディアの更新日時。value の URL にクエリパラメータとして付与され、キャッシュ無効化に使用される。"),
})

export const Media = z.union([
  MediaImage,
  MediaVideo,
])

export type MediaImage = z.infer<typeof MediaImage>
export type MediaVideo = z.infer<typeof MediaVideo>
export type Media = z.infer<typeof Media>

export const DocumentStatusPublic = z.literal("public").describe("公開状態。作成が完了しており、read をユーザーに許容しているような状態全般を指す。")
export const DocumentStatusHidden = z.literal("hidden").describe("非公開状態。作成途中だったり、作成後に非公開にしたケースを指す。")
export const DocumentStatusDeleted = z.literal("deleted").describe("削除済み状態。管理ツール上で削除されたが、履歴として残る。")

export const DocumentStatus = z.enum([
  DocumentStatusPublic.value,
  DocumentStatusHidden.value,
]).describe("ドキュメントの状態。")

export const InitialLookStatus = z.enum([
  DocumentStatusPublic.value,
  DocumentStatusHidden.value,
  DocumentStatusDeleted.value,
]).describe("初回起動時ホロスーツ登録の状態。public=有効、hidden=無効、deleted=削除済み")

export type DocumentStatusPublic = z.infer<typeof DocumentStatusPublic>
export type DocumentStatusHidden = z.infer<typeof DocumentStatusHidden>
export type DocumentStatusDeleted = z.infer<typeof DocumentStatusDeleted>
export type DocumentStatus = z.infer<typeof DocumentStatus>
export type InitialLookStatus = z.infer<typeof InitialLookStatus>
